module.exports = __webpack_public_path__ + "media/print/fonts_quicksand-d8bcc236.png";